export default function auth() {

    const $root = jQuery('#customer_login.auth');

    $root.on('click', '[data-auth-tab]', function (e) {
        e.preventDefault();
        $root.attr('data-active', jQuery(this).data('auth-tab'));
    });

}
